<template>
  <div>
    <apexchart :options="chartOptions" :series="series" type="pie" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts
  },
  props: {
    propSeries: Array,
    propChartLabel: Array
  },
  data() {
    return {
      series: this.propSeries,
      chartOptions: {
        chart: {
          type: "pie"
        },
        labels: this.propChartLabel,
        colors: ["#EE4D2D", "#03AC0E", "#E31E52", "#1890FF"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%"
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ],
        title: {
          text: "Total Scrape Semua Marketplace",
          style: {
            fontFamily: "CircularStd",
            fontSize: "20px",
            fontWeight: 500
          }
        },
        noData: {
          text: "Tidak ada data yang tersedia"
        }
      }
    };
  }
};
</script>

<style>
.apexcharts-legend-text {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/views/monitoring/summary/components/totalScrapeMarketplace.vue